import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PreviewPage.css";

const PreviewPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Data coming from EditPage navigate("/preview", { state: {...} })
  const {
    mediaList = [],
    music,
    musicType,
    uploadedMusicId,
    transitionStyle = "default",
  } = location.state || {};

  const videoRef = useRef(null);
  const musicRef = useRef(null);

  const [currentIndex, setCurrentIndex] = useState(0);

  /* ---------------- SAFE VIDEO LOAD & PLAY ---------------- */
  const loadAndPlay = (src) => {
    const video = videoRef.current;
    if (!video || !src) return;

    video.pause();
    video.removeAttribute("src"); // important for some browsers
    video.load();

    video.src = src;
    video.load();

    const playWhenReady = () => {
      video.play().catch(() => {});
      video.removeEventListener("canplay", playWhenReady);
    };

    video.addEventListener("canplay", playWhenReady);
  };

  /* ---------------- SAFE AUDIO LOAD & PLAY ---------------- */
  const loadAndPlayMusic = () => {
    const audio = musicRef.current;
    if (!audio) return;

    audio.pause();
    audio.removeAttribute("src");
    audio.load();

    if (musicType === "system" && music) {
      audio.src = `/music/${music}`;
    } else if (musicType === "user" && uploadedMusicId) {
      audio.src = `/uploads/music/${uploadedMusicId}.mp3`;
    } else {
      return;
    }

    audio.load();

    const playMusic = () => {
      audio.loop = true;
      audio.volume = 0.5;
      audio.play().catch(() => {});
      audio.removeEventListener("canplay", playMusic);
    };

    audio.addEventListener("canplay", playMusic);
  };

  /* ---------------- INIT VIDEO ---------------- */
  useEffect(() => {
    if (mediaList.length > 0) {
      setCurrentIndex(0);
      loadAndPlay(mediaList[0]);
    }
  }, [mediaList]);

  /* ---------------- INIT MUSIC ---------------- */
  useEffect(() => {
    loadAndPlayMusic();
  }, [music, musicType, uploadedMusicId]);

  /* ---------------- WHEN A CLIP ENDS ---------------- */
  const handleEnded = () => {
    const next = currentIndex + 1;
    if (next < mediaList.length) {
      setCurrentIndex(next);
      loadAndPlay(mediaList[next]);
    } else {
      // Stop music when preview finishes
      if (musicRef.current) {
        musicRef.current.pause();
      }
    }
  };

  /* ---------------- PLAY AGAIN ------------------ */
  const replayAll = () => {
    setCurrentIndex(0);
    loadAndPlay(mediaList[0]);
    loadAndPlayMusic();
  };

  return (
    <div className="preview-page">
      <div className="preview-header">
        <button onClick={() => navigate(-1)}>← Back to Edit</button>
        <h2>Preview Video</h2>
      </div>

      <div className={`preview-player transition-${transitionStyle}`}>
        <video
          ref={videoRef}
          className="preview-video"
          controls
          onEnded={handleEnded}
          playsInline
        />
        <audio ref={musicRef} />
      </div>

      <div className="preview-footer">
        <button onClick={replayAll}>▶ Play Again</button>
      </div>
    </div>
  );
};

export default PreviewPage;
